module.exports = __webpack_public_path__ + "static/media/back.c111e501.svg";